// @flow
import React from 'react';
import styled from 'styled-components';
import { Checkbox } from '@atlaskit/checkbox';
import type { BindProps } from 'modules/form/BindFieldInput';

// AK's checkbox is 10px deeper than other fields. Pulling it out.
const Realign = styled.div`
  margin-left: -5px;
`;

export default ({ field, ...props }: BindProps<typeof Checkbox>) =>
  !!field && (
    <Realign>
      <Checkbox
        {...props}
        isChecked={field.value}
        onChange={(e: any) => {
          field.edit(e.target.checked);
          field.onBlur();
        }}
      />
    </Realign>
  );
